import "@testing-library/jest-dom";
import React from "react";
import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import { ChatPanel } from "./ChatPanel";

const mockCancelStream = jest.fn(async () => undefined);
const mockProviderConfigs: Array<Record<string, unknown>> = [];
let mockChatState: Record<string, unknown> = {};

jest.mock("@metalmind-ab/mmagent-chat-ui/styles.css", () => ({}), {
  virtual: true,
});
jest.mock("@metalmind-ab/mmagent-chat-ui", () => {
  const actual = jest.requireActual("@metalmind-ab/mmagent-chat-ui");
  return {
    ...actual,
    ChatProvider: (props: { config: Record<string, unknown> }) => {
      mockProviderConfigs.push(props.config);
      return actual.ChatProvider(props);
    },
    useChat: () => ({
      messages: [],
      sendMessage: jest.fn(),
      cancelStream: mockCancelStream,
      isLoading: true,
      isStopping: false,
      stopError: null,
      ...mockChatState,
    }),
  };
});
jest.mock("../../../../../hooks/useAuthHeaders", () => ({
  useAuthHeaders: () => async () => ({ Authorization: "test-token" }),
}));
jest.mock("../../../../../config/runtimeConfig", () => ({
  getApiBaseUrl: () => "http://localhost",
}));
jest.mock("../../../../../utils/chatResumeOptions", () => ({
  buildChatResumeOptions: () => ({}),
}));

beforeEach(() => {
  mockProviderConfigs.length = 0;
  mockCancelStream.mockClear();
  mockChatState = {};
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
});

it("configures confirmed Stop and shows it during a Meridian structure run", async () => {
  render(
    <ChatPanel
      workspaceId="workspace-1"
      documentTypeId={7}
      documentTypeName="Template"
      onSectionsChanged={jest.fn()}
      onClose={jest.fn()}
    />,
  );
  await waitFor(() => expect(mockProviderConfigs.length).toBeGreaterThan(0));
  expect(mockProviderConfigs[0].cancelSubmission).toBe(true);
  expect(mockProviderConfigs[0].headers).toMatchObject({
    "X-Workspace-Id": "workspace-1",
    "X-Document-Type-Id": "7",
  });
  fireEvent.click(
    await screen.findByRole("button", { name: /stop generating/i }),
  );
  expect(mockCancelStream).toHaveBeenCalledTimes(1);
});

it("keeps Stop available when the server did not confirm cancellation", async () => {
  mockChatState = { stopError: "Only the starter may stop this run." };
  render(
    <ChatPanel
      workspaceId="workspace-1"
      documentTypeId={7}
      documentTypeName="Template"
      onSectionsChanged={jest.fn()}
      onClose={jest.fn()}
    />,
  );
  expect(
    await screen.findByText("Only the starter may stop this run."),
  ).toBeInTheDocument();
  expect(
    await screen.findByRole("button", { name: /stop generating/i }),
  ).toBeEnabled();
});

it("disables Meridian Stop while server confirmation is pending", async () => {
  mockChatState = { isStopping: true };
  render(
    <ChatPanel
      workspaceId="workspace-1"
      documentTypeId={7}
      documentTypeName="Template"
      onSectionsChanged={jest.fn()}
      onClose={jest.fn()}
    />,
  );
  expect(
    await screen.findByRole("button", { name: /stopping/i }),
  ).toBeDisabled();
});
